import { useQuery } from "@tanstack/react-query";
import { MetricRequest } from "../types/api/metrics/request";
import { fetchAvailableMetrics } from "../services/metrics";
import { fetchMetric } from "../services/metrics";

export const useAvailableMetricsQuery = () => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["available-metrics"],
    queryFn: () => fetchAvailableMetrics(),
    retry: 0,
  });
};

export const useMetricQuery = (
  metricName: string | undefined,
  metricType: string | undefined,
  params?: MetricRequest,
  options?: { enabled?: boolean }
) => {
  const isEnabled = Boolean(
    metricName && metricType && options?.enabled !== false
  );

  return useQuery({
    queryKey: ["metric", metricName, metricType, params],
    queryFn: () => {
      if (!metricName || !metricType) {
        return Promise.reject(new Error("Blocked: missing parameters"));
      }

      return fetchMetric(metricName, metricType, params);
    },
    enabled: isEnabled,
    retry: 0,
    refetchOnWindowFocus: false,
  });
};
